var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSideBar),expression:"showSideBar"}],staticClass:"increment-service production-platform"},[_c('Sidebar',{attrs:{"default-active":_vm.defaultActive,"menu-data":_vm.menuData,"router":false},on:{"routerChange":_vm.routerChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }